import { ENVS, REGIONS, Env, Region } from '@adsk/acs-sc-web-platform-api';

export const SCHEDULE_ENV_CONFIG_KEYS: Record<string, string> = {
  SCHEDULE_BE: 'SCHEDULE_BE',
  SCHEDULE_FE: 'SCHEDULE_FE',
};

type Keys = typeof SCHEDULE_ENV_CONFIG_KEYS;

type Key = Keys[keyof Keys];

const US_CONFIG: Record<Env, Record<Key, string>> = {
  [ENVS.QA]: {
    [SCHEDULE_ENV_CONFIG_KEYS.SCHEDULE_BE]:
      'https://developer-stg.api.autodesk.com/construction/schedule-qa/v1',
    [SCHEDULE_ENV_CONFIG_KEYS.SCHEDULE_FE]:
      'https://acc-qa.autodesk.com/build/schedule',
  },
  [ENVS.STAGING]: {
    [SCHEDULE_ENV_CONFIG_KEYS.SCHEDULE_BE]:
      'https://developer-stg.api.autodesk.com/construction/schedule/v1',
    [SCHEDULE_ENV_CONFIG_KEYS.SCHEDULE_FE]:
      'https://acc-staging.autodesk.com/build/schedule',
  },
  [ENVS.PRODUCTION]: {
    [SCHEDULE_ENV_CONFIG_KEYS.SCHEDULE_BE]:
      'https://developer.api.autodesk.com/construction/schedule/v1',
    [SCHEDULE_ENV_CONFIG_KEYS.SCHEDULE_FE]:
      'https://acc.autodesk.com/build/schedule',
  },
};

const EMEA_CONFIG: Record<Env, Record<Key, string>> = {
  ...US_CONFIG,
  [ENVS.PRODUCTION]: {
    ...US_CONFIG[ENVS.PRODUCTION],
    [SCHEDULE_ENV_CONFIG_KEYS.SCHEDULE_FE]:
      'https://acc.autodesk.eu/build/schedule',
  },
};

const APAC_CONFIG: Record<Env, Record<Key, string>> = {
  ...US_CONFIG,
  [ENVS.STAGING]: {
    ...US_CONFIG[ENVS.STAGING],
    [SCHEDULE_ENV_CONFIG_KEYS.SCHEDULE_FE]:
      'https://acc-staging.apac.autodesk.com/build/schedule',
  },
  [ENVS.PRODUCTION]: {
    ...US_CONFIG[ENVS.PRODUCTION],
    [SCHEDULE_ENV_CONFIG_KEYS.SCHEDULE_FE]:
      'https://acc.apac.autodesk.com/build/schedule',
  },
};

const AUS_CONFIG: Record<Env, Record<Key, string>> = {
  ...US_CONFIG,
  [ENVS.STAGING]: {
    ...US_CONFIG[ENVS.STAGING],
    [SCHEDULE_ENV_CONFIG_KEYS.SCHEDULE_FE]:
      'https://acc-staging.aus.autodesk.com/build/schedule',
  },
  [ENVS.PRODUCTION]: {
    ...US_CONFIG[ENVS.PRODUCTION],
    [SCHEDULE_ENV_CONFIG_KEYS.SCHEDULE_FE]:
      'https://acc.aus.autodesk.com/build/schedule',
  },
};

type Configs = typeof US_CONFIG;
export const ENV_CONFIGS: Record<Region, Configs> = {
  [REGIONS.US]: US_CONFIG,
  [REGIONS.EMEA]: EMEA_CONFIG,
  [REGIONS.APAC]: APAC_CONFIG,
  [REGIONS.AUS]: AUS_CONFIG,
};

export const COMPOUND_ID_DELIMITER = ':';
